import React from "react";
import {useSelector} from "react-redux";
import axios from "axios";
import {baseURL} from "../config";
import {useStyletron} from "baseui";
import {Label2, Label3, ParagraphSmall} from "baseui/typography";
import {Card, StyledBody} from "baseui/card";
import {StatefulPopover} from "baseui/popover";
import {Block} from "baseui/block";
import moment from "moment";
import momentTimezone from "moment-timezone";

const client = axios.create({
    baseURL,
    headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
    },
});


function OrderAssignments() {
    const {order} = useSelector((state) => state.order);
    const [assignments, setAssignments] = React.useState(null);
    const [css] = useStyletron()

    let orderId = order.id;
    React.useEffect(() => {
        client.get(`/api/admin/orders/${orderId}/assignments`).then((response) => {
            setAssignments(response.data);
        });
    }, []);


    if (!assignments) return <Label3>No assignments</Label3>;
    const allAssignments = assignments?.assignments

    const listAssignments = allAssignments.map((assgnmnt, index)=>
        <Card className={css({
            marginBottom: '0.5rem',
            marginRight: '0.5rem',
            width: "45%"
        })}>
            <StyledBody>
                <ParagraphSmall>
                    Driver: {assgnmnt.driver.name}
                </ParagraphSmall>
                {assgnmnt.driver?.phone && (
                    <ParagraphSmall>
                        Phone: {assgnmnt.driver?.phone}
                    </ParagraphSmall>
                )}
                {assgnmnt?.vehicle && (
                    <ParagraphSmall>
                        Reg No.: {assgnmnt.vehicle?.licence_plate}
                    </ParagraphSmall>
                )}

                {assgnmnt?.user?.login && (
                    <ParagraphSmall>
                        Assigned by: System
                    </ParagraphSmall>
                )}

                {assgnmnt?.user?.personnel && (
                    <ParagraphSmall>
                        Assigned by: {assgnmnt?.user?.personnel?.name}
                    </ParagraphSmall>
                )}

                <StatefulPopover
                    content={() => (
                        <div className={css({
                            minWidth: "250px",
                            backgroundColor:"#ffffff",
                            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                            padding:"0.5rem",
                            maxWidth:"280px"
                        })}>
                            <Label2 className={css({
                                marginBottom: '0.25rem',
                                fontWeight: '600'
                            })}>Driver Details</Label2>
                            <Label3>Name: <span>{assgnmnt.driver.name}</span></Label3>
                            <Label3>Phone: <span>{assgnmnt.driver?.phone}</span></Label3>
                            <Label3 className={css({
                                marginBottom: '0.5rem'
                            })}>Email: <span>{assgnmnt.driver?.email}</span></Label3>

                            <Label2 className={css({
                                marginBottom: '0.25rem',
                                fontWeight: '600'
                            })}>Vehicle Details</Label2>
                            <Label3 className={css({
                                marginBottom: '0.5rem'
                            })}>Reg No: <span>{assgnmnt.vehicle?.licence_plate}</span></Label3>

                            <Label2 className={css({
                                marginBottom: '0.25rem',
                                fontWeight: '600'
                            })}>Assignment Details</Label2>

                            <Label3> Assigned At: {moment(
                                momentTimezone.tz(
                                    assgnmnt?.changed_at,
                                    momentTimezone.tz.guess()
                                )
                            ).format("lll")}</Label3>

                            {assgnmnt.user?.personnel && <Label3>Assigned By: <span>{assgnmnt.user?.personnel.name}</span></Label3>}
                            {assgnmnt.user?.login && <Label3>Assigned: System</Label3>}
                            {assgnmnt.distance && <Label3>Distance: <span>{assgnmnt.distance} {assgnmnt.distance_unit}</span></Label3>}
                        </div>
                    )}
                >
                    <button className={css({
                        lineHeight: "12px",
                        fontSize: "12px",
                        cursor:"pointer",
                        marginTop: "1px",
                        marginRight: "2px",
                        top:"0",
                        right:"0",
                        border:"none",
                        background:"transparent",
                        color: "#ecc910"
                    })}>See More Details</button>
                </StatefulPopover>
            </StyledBody>
        </Card>
    )
    return (
        <div className={css({
            position: "relative",
            width: "100%",
            display: "flex",
            flexWrap:"wrap",
            padding: "0.5rem",
            background: "#FFFFFF",
            maxHeight: "400px",
            overflow: "auto",
            justifyContent:"center"
        })}>{listAssignments}</div>
    )
}

export default OrderAssignments